<template>
  <add-edit-dialog v-show="visible">
    <crm-panel :title="title" v-loading="loading">
      <div class="page-buttons">
        <crm-button
          :disabled="button.save"
          :text="'保存'"
          :buttonType="button.save ? 'info' : 'primary'"
          @click="handleSave()"
        >
        </crm-button>
        <crm-button
          :disabled="button.cancel"
          :buttonType="button.cancel ? 'info' : 'plain'"
          :text="'取消'"
          @click="handleCancel()"
        >
        </crm-button>
      </div>
      <el-form
        label-width="160px"
        ref="form"
        :model="form"
        :rules="formRules"
        class="add-edit-form"
      >
        <el-row>
          <el-col :span="20">
            <el-form-item label="标题：" prop="docTitle">
              <el-input v-model="form.docTitle" style="width: 60%;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="所属目录：" prop="menuId">
              <!-- <div style="width: 60%;"> -->
              <el-cascader
                ref="selectMenu"
                v-model="form.menuId"
                :show-all-levels="false"
                :options="knowTreeData"
                :props="{ checkStrictly: true, emitPath: false }"
              />
              <!-- </div> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="内容：" prop="context">
              <crm-editor
                ref="editor"
                :data="context"
                @funcEditor="funcEditor"
              ></crm-editor>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="附件：">
              <el-upload
                ref="upload"
                multiple
                action="action"
                :http-request="handleUploadFile"
                :before-upload="beforeAvatarUpload"
                :on-success="handleOnSuccess"
                :on-error="handleOnError"
                :on-change="handleUploadChange"
                :file-list="fileList"
                :before-remove="beforeRemove"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  单个图片文件最大支持5MB，其他文件最大支持50MB，上传请耐心等待
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="权限：" prop="authorization">
              <el-select
                v-model="form.authorization"
                @change="handleChangeOther"
              >
                <el-option
                  v-for="item in authorizationList"
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                >
                </el-option>
              </el-select>
              <el-cascader
                style="width: 60%;"
                ref="cascaderId"
                :show-all-levels="false"
                v-show="teamObj.visible"
                v-model="form.teamList"
                :options="knowTeam"
                :props="teamObj.props"
                collapse-tags
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="其他设置：">
              <el-checkbox
                label="置顶"
                v-model="form.top"
                v-show="
                  auth.knowledgeDocTop && auth.knowledgeDocTop.toggleStatus
                "
              />
              <el-checkbox label="禁止复制" v-model="form.copy" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </crm-panel>
  </add-edit-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import city from '@/scripts/city-diction';
import { uploadFileVerify } from '@/scripts/reg';

import AddEditDialog from '@/components/base/addEditDialog';
import CrmPanel from '@/components/base/crmPanel';
import CrmButton from '@/components/base/crmButton';
import CrmEditor from '@/components/base/crmEditor';

export default {
  props: {
    type: String,
    visible: Boolean,
    item: Object,
    fileListArr: Array,
  },
  components: {
    AddEditDialog,
    CrmPanel,
    CrmButton,
    CrmEditor,
  },
  data() {
    return {
      title: '新增文档',
      loading: false,
      context: '',
      // 一级二级单选，三级多选
      shareScopeEnd: [],
      defaultForm: {
        docTitle: null,
        menuId: null,
        context: null,
        top: 0,
        authorization: 0,
        copy: 0,
        deleteFileIds: [],
        uploadFileIds: [],
        fileNumber: 0,
        teamIds: [],
        teamList: [],
      },
      form: {
        docTitle: null,
        menuId: null,
        context: null,
        top: 0,
        authorization: 0,
        copy: 0,
        deleteFileIds: [],
        uploadFileIds: [],
        fileNumber: 0,
        teamIds: [],
        teamList: [],
      },
      formRules: {
        docTitle: [
          { required: true, message: '请填写标题', trigger: 'blur' },
          { max: 50, message: '最多50个字', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const regText = /^[a-zA-Z_【】《》（）—_\u4e00-\u9fa5_0-9]+$/;
              if (!regText.test(value)) {
                callback('标题不能包含特殊字符');
              }
              callback();
            },
            trigger: 'change',
          },
        ],
        menuId: [
          { required: true, message: '请选择所属目录', trigger: 'blur' },
        ],
        context: [
          { required: true, message: '请填写文本内容', trigger: 'blur' },
          { max: 10000, message: '最多10000个字', trigger: 'blur' },
        ],
      },
      authorizationList: [
        {
          value: 0,
          label: '本部门（不包含下级）',
        },
        {
          value: 1,
          label: '指定团队可见',
        },
      ],
      fileList: [],
      teamObj: {
        visible: false,
        props: {
          multiple: true,
          checkStrictly: false,
          emitPath: true,
        },
      },
      button: {
        save: false,
        cancel: false,
      },
      submit: {
        add: {
          save: 'addKnowDoc',
          message: '新增成功',
        },
        edit: {
          save: 'updateKnowDoc',
          message: '编辑成功',
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
      allSalesman: 'clue/allSalesman',
      clueSource: 'common/clueSource',
      knowTeam: 'knowledge/knowTeam',
      knowTreeData: 'knowledge/knowTreeData',
      detail: 'knowledge/detail',
    }),
  },
  watch: {
    item(val) {
      if (val.id) {
        this.form = this.handleDealDataToDoc(JSON.parse(JSON.stringify(val)));
        this.context = val.context;
      } else {
        this.form = this.handleDealDataToDoc({
          ...this.defaultForm,
          ...JSON.parse(JSON.stringify(val)),
        });
      }
      this.getKnowTeam();
      this.getTreeData({ menuName: '' });
    },
    type(val) {
      if (val === 'edit') {
        this.title = '编辑文档';
      } else {
        this.title = '新增文档';
      }
    },
  },
  methods: {
    ...mapActions({
      getKnowTeam: 'knowledge/getKnowTeam',
      getTreeData: 'knowledge/getTreeData',
      uploadCompactFile: 'knowledge/uploadCompactFile',
      addKnowDoc: 'knowledge/addKnowDoc',
      updateKnowDoc: 'knowledge/updateKnowDoc',
      getKnowDetail: 'knowledge/getKnowDetail',
    }),
    handleDealDataToSubmit(data) {
      return {
        ...data,
        top: data.top ? 1 : 0,
        copy: data.copy ? 1 : 0,
      };
    },
    handleDealDataToDoc(data) {
      // eslint 规则不支持布尔值的三元运算符
      if (data.top === 1) {
        data.top = true;
      } else {
        data.top = false;
      }
      if (data.copy === 1) {
        data.copy = true;
      } else {
        data.copy = false;
      }

      // 处理附件
      if (data.fileList && data.fileList.length) {
        this.fileList = data.fileList.map(v => ({
          name: v.fileName,
          url: v.fileUrl,
          id: v.id,
        }));
      }
      if (data.authorization === 1) {
        this.teamObj.visible = true;
      }
      // 返回form表单数据
      return {
        id: data.id,
        docTitle: data.docTitle,
        menuId: data.menuId,
        context: data.context,
        top: data.top,
        authorization: data.authorization,
        copy: data.copy,
        deleteFileIds: [],
        uploadFileIds: [],
        fileNumber: data.attachmentNumber,
        teamIds: data.teamIds,
        teamList: data.teamList,
      };
    },
    handlePreview(file, fileList) {},
    handleRemove(file, fileList) {},
    // 展示的文件列表中删除文件，将传给后端的文件id删除
    beforeRemove(file) {
      if ('raw' in file) {
        const delIndex = this.fileList.findIndex(
          item => item.id === file.raw.id,
        );
        if (delIndex !== -1) {
          this.form.uploadFileIds.splice(delIndex, 1);
        }
      } else {
        const isNewFile = this.form.uploadFileIds.length > 0
          ? this.form.uploadFileIds.findIndex(item => item === file.id)
          : -1;
        if (isNewFile !== -1) {
          this.form.uploadFileIds.splice(isNewFile, 1);
        } else {
          this.form.deleteFileIds.push(file.id);
        }
      }
      return true;
    },
    // 文件上传前文件大小, 文件重复拦截
    async beforeAvatarUpload(file) {
      /* eslint-disable */
      let isLt2M = true;
      const reg = /(.*)\.(jpg|bmp|gif|ico|pcx|jpeg|tif|png|raw|tga)$/i;

      if (file.size === 0) {
        this.$message({
          type: 'info',
          message: '文件不能为空!',
        });
        return false;
      }

      if (reg.test(file.type)) {
        isLt2M = file.size / 1024 / 1024 < 5;
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 5MB!');
          return Promise.reject();
        }
      } else {
        isLt2M = file.size / 1024 / 1024 < 50;
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 50MB!');
          return Promise.reject();
        }
      }

      if (this.fileList.length) {
        const isSame = this.fileList.some(v => v.name === file.name);
        if (isSame) {
          this.$message({
            type: 'info',
            message: '该文件已存在!',
          });
          return Promise.reject();
        }
      }
      try {
        return await uploadFileVerify(file.name);
      } catch (e) {
        this.$message(e);
        return Promise.reject();
      }
    },
    handleUploadChange(file, fileList) {
      let k = 0;
      this.fileList.forEach(item => {
        if (item.status === 'ready') {
          k = k + 1;
        }
      });
      if (k === 0) {
        this.$notify.closeAll();
        this.notify = null;
      }
    },
    // 文件上传成功时同步文件列表
    handleOnSuccess(response, file, fileList) {
      this.$message({
        type: 'success',
        message: file.name + '上传成功！',
      });
      this.fileList = fileList;
    },
    // 失败的时候fileList会自动删除-可以直接更新
    handleOnError(response, file, fileList) {
      this.fileList = fileList;
      this.$message({
        type: 'error',
        message: file.name + '上传失败！',
      });
      if (this.fileList.length === 0) {
        this.$notify.closeAll();
        this.notify = null;
      }
    },
    // 文件上传
    handleUploadFile(item) {
      this.handleButtonStatus(true);
      if (!this.notify) {
        this.notify = this.$notify({
          iconClass: 'el-icon-loading',
          title: '',
          message: '正在上传中，请稍后...',
          duration: 0,
          showClose: false,
        });
      }
      const params = new FormData();

      params.append('file', item.file);
      params.append('fileName', item.file.name);

      this.uploadCompactFile({
        params,
        config: { 'Content-Type': 'multipart/form-data', timeout: 100000 },
      })
        .then(res => {
          item.file.id = res.data.data;
          item.onSuccess();
          this.form.uploadFileIds.push(res.data.data);
          this.handleButtonStatus(false);
        })
        .catch(err => {
          item.onError();
          this.handleButtonStatus(false);
        });
    },
    handleChangeFile(file, fileList) {
      // this.fileList = fileList.slice(-3);
    },
    funcEditor(data) {
      this.form.context = data;
    },
    handleChangeOther(value) {
      if (value === 1) {
        this.teamObj.visible = true;
      } else {
        this.teamObj.visible = false;
      }
    },
    handleSave() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const request = this.submit[this.type].save;
          const { teamList, top, ...other } = this.form;
          // teamList传二维数组 用于反显 teamIds给后端处理关联关系 需要拍平去重
          const data = this.handleDealDataToSubmit({
            ...other,
            teamList,
            top: top ? 1 : 0,
            teamIds: teamList
              ? Array.from(new Set(teamList.flat(Infinity)))
              : [],
          });
          this[request](data)
            .then(() => {
              this.$message.success(this.submit[this.type].message);
              this.$emit('success');
              this.handleCancel();
            })
            .catch(() => {});
        }
      });
    },
    handleCancel() {
      this.form = { ...this.defaultForm };
      this.fileList = [];
      this.$refs.form.resetFields();
      this.context = '';
      this.$refs.editor.handleClear();
      this.teamObj.visible = false;
      this.$emit('close');
    },
    handleButtonStatus(status) {
      this.button.save = status;
      this.button.cancel = status;
    },
  },
};
</script>

<style></style>
